// eslint-disable-next-line spellcheck/spell-checker
import { lighten, darken, transparentize as opacity } from 'polished'

const source = {
  // App colors
  white: '#FFFFFF',
  black: '#222222',
  gray: '#E0E0E0',
  green: '#219653',
  blue: '#2F80ED',
  red: '#EB5757',
  pink: '#BB6BD9',
  orange: '#F2994A',

  // One Tree brand colors
  logo: '#1D4F91',
  giftVouchers: '#84bd00',
  specialOffers: '#dc4405',
  tickets: '#7d2248',

  // One Tree card status colors
  dispatched: '#F89406',
  paid: '#3A87AD',
  redeemed: '#468847',
  cancelled: '#777777',
  booked: '#333333',
  expired: '#B94A48',
}

const colors = {
  black: source.black,
  shadow: opacity(0.75, source.black),
  darkShadow: opacity(0.1, source.black),

  white: source.white,
  faded: opacity(0.6, source.white),

  lightestGray: lighten(0.1, source.gray),
  lightGray: lighten(0.07, source.gray),
  gray: source.gray,
  darkGray: darken(0.1, source.gray),
  darkerGray: darken(0.3, source.gray),
  darkestGray: darken(0.58, source.gray),

  green: source.green,
  lightGreen: lighten(0.08, source.green),
  lightestGreen: lighten(0.4, source.green),

  blue: source.blue,
  lightBlue: lighten(0.1, source.blue),
  lightestBlue: lighten(0.4, source.blue),

  red: source.red,
  lightRed: lighten(0.08, source.red),
  lightestRed: lighten(0.34, source.red),

  pink: source.pink,
  orange: source.orange,

  logo: source.logo,
  giftVouchers: source.giftVouchers,
  specialOffers: source.specialOffers,
  tickets: source.tickets,

  dispatched: source.dispatched,
  paid: source.paid,
  redeemed: source.redeemed,
  cancelled: source.cancelled,
  booked: source.booked,
  expired: source.expired,
}

export default colors
